<!-- Documentos -->
<form [formGroup]="formDocumentos" class="contido-50vh" *ngIf="step == 0">
    <div class="row">
        <!-- ESTADO CIVIL -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    Estado Civil
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <select class="custom-select form-control" id="validationTooltip04" formControlName="estCivil"
                    [ngClass]="formDocumentos.controls.estCivil.valid && !formDocumentos.controls.estCivil.untouched ? 'is-valid' : !formDocumentos.controls.estCivil.untouched && !formDocumentos.controls.estCivil.pristine ? 'is-invalid' : ''">
                    <option selected disabled value="">Selecione</option>
                    <option value="SO">Solteiro</option>
                    <option value="CA">Casado</option>
                    <option value="DE">Desquitado</option>
                    <option value="DI">Divorciado</option>
                    <option value="VI">Viúvo</option>
                    <option value="OU">Outros</option>
                </select>
                <input-feedback label="Estado Civil" [control]="formDocumentos.controls.estCivil" showSuccess="false">
                </input-feedback>
            </div>
        </div>
        <!-- FIM ESTADO CIVIL -->

        <!-- ESCOLARIDADE -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    Escolaridade
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <select class="custom-select form-control" id="validationTooltip04" formControlName="escolaridade"
                    [ngClass]="formDocumentos.controls.escolaridade.valid && !formDocumentos.controls.escolaridade.untouched ? 'is-valid' : !formDocumentos.controls.escolaridade.untouched && !formDocumentos.controls.escolaridade.pristine ? 'is-invalid' : ''">
                    <option selected disabled value="">Selecione</option>
                    <option value="S">Sem instrução</option>
                    <option value="1G">Primeiro grau</option>
                    <option value="2G">Segundo grau</option>
                    <option value="SI">Superior incompleto</option>
                    <option value="SC">Superior completo</option>
                    <option value="PO">Pós-graduação</option>
                    <option value="ME">Mestrado</option>
                    <option value="DR">Doutorado</option>
                    <option value="OU">Outros</option>
                </select>
                <input-feedback label="Escolaridade" [control]="formDocumentos.controls.escolaridade"></input-feedback>
            </div>
        </div>
        <!-- FIM ESCOLARIDADE -->

        <!-- TELEFONE -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="telefone">
                    Telefone
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <input type="text" class="form-control" id="telefone" aria-describedby="telefone"
                    formControlName="telefone" maxlength="16"
                    [ngClass]="formDocumentos.controls.telefone.valid && !formDocumentos.controls.telefone.untouched ? 'is-valid' : !formDocumentos.controls.telefone.untouched && !formDocumentos.controls.telefone.pristine ? 'is-invalid' : ''"
                    mask="(00) 0 0000-0000" style="text-transform:uppercase">
                <input-feedback label="Telefone" [control]="formDocumentos.controls.telefone"></input-feedback>
            </div>
        </div>
        <!-- FIM TELEFONE -->
    </div>
</form>
<!-- Final Documentos -->

<!-- Endereço -->
<form [formGroup]="formEndereco" *ngIf="step == 1">
    <div class="row">
        <div class="col-sm col-sm-12 col-md-12 col-lg-11 col-xl-12 d-flex justify-content-center mb-2 mt-2">
            <h2>Endereço de Cobrança</h2>
        </div>
    </div>
    <div class="row area-endereco">
        <!-- CEP -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    CEP
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <input type="text" class="form-control" id="cep" aria-describedby="cep" formControlName="cep"
                    maxlength="9"
                    [ngClass]="formEndereco.controls.cep.valid && !formEndereco.controls.cep.untouched ? 'is-valid' : !formEndereco.controls.cep.untouched && !formEndereco.controls.cep.pristine ? 'is-invalid' : ''"
                    mask="00000-000" style="text-transform:uppercase"
                    (change)="changeCep(formEndereco.controls.cep.value)">
                <input-feedback label="CEP" [control]="formEndereco.controls.cep"></input-feedback>
            </div>
        </div>
        <!-- FIM CEP -->

        <!-- LOGRADOURO -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    Logradouro
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <input type="text" class="form-control" id="logradouro" aria-describedby="logradouro"
                    formControlName="logradouro" maxlength="50"
                    [ngClass]="formEndereco.controls.logradouro.valid && !formEndereco.controls.logradouro.untouched ? 'is-valid' : !formEndereco.controls.logradouro.untouched && !formEndereco.controls.logradouro.pristine ? 'is-invalid' : ''">
                <input-feedback label="Logradouro" [control]="formEndereco.controls.logradouro"></input-feedback>
            </div>
        </div>
        <!-- FIM LOGRADOURO -->

        <!-- NÚMERO ENDEREÇO -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    Número
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <input type="number" class="form-control" id="numero" aria-describedby="numero" formControlName="numero"
                    maxlength="10"
                    [ngClass]="formEndereco.controls.numero.valid && !formEndereco.controls.numero.untouched ? 'is-valid' : !formEndereco.controls.numero.untouched && !formEndereco.controls.numero.pristine ? 'is-invalid' : ''">
                <input-feedback label="Número" [control]="formEndereco.controls.numero"></input-feedback>
            </div>
        </div>
        <!-- FIM NÚMERO ENDEREÇO -->

        <!-- NÚMERO ENDEREÇO -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">Complemento</label>
                <input type="text" class="form-control" id="complemento" aria-describedby="complemento"
                    formControlName="complemento" maxlength="50"
                    [ngClass]="formEndereco.controls.complemento.valid && !formEndereco.controls.complemento.untouched ? 'is-valid' : !formEndereco.controls.complemento.untouched && !formEndereco.controls.complemento.pristine ? 'is-invalid' : ''">
                <input-feedback label="Complemento" [control]="formEndereco.controls.complemento"></input-feedback>
            </div>
        </div>
        <!-- FIM NÚMERO ENDEREÇO -->

        <!-- NÚMERO BAIRRO -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    Bairro
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <input type="text" class="form-control" id="bairro" aria-describedby="bairro" formControlName="bairro"
                    maxlength="50"
                    [ngClass]="formEndereco.controls.bairro.valid && !formEndereco.controls.bairro.untouched ? 'is-valid' : !formEndereco.controls.bairro.untouched && !formEndereco.controls.bairro.pristine ? 'is-invalid' : ''">
                <input-feedback label="Bairro" [control]="formEndereco.controls.bairro"></input-feedback>
            </div>
        </div>
        <!-- FIM NÚMERO BAIRRO -->

        <!-- LOCALIDADE -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    Localidade
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <input type="text" class="form-control" id="localidade" aria-describedby="localidade"
                    formControlName="localidade" maxlength="50"
                    [ngClass]="formEndereco.controls.localidade.valid && !formEndereco.controls.localidade.untouched ? 'is-valid' : !formEndereco.controls.localidade.untouched && !formEndereco.controls.localidade.pristine ? 'is-invalid' : ''">
                <input-feedback label="Localidade" [control]="formEndereco.controls.localidade"></input-feedback>
            </div>
        </div>
        <!-- FIM LOCALIDADE -->

        <!-- UF -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    UF
                    <i class="fas fa-info-circle icon-info icon-info-primary" placement="right"
                        ngbPopover="Campo obrigatório"></i>
                </label>
                <select class="custom-select form-control" id="validationTooltip04" formControlName="uf"
                    [ngClass]="formEndereco.controls.uf.valid && !formEndereco.controls.uf.untouched ? 'is-valid' : !formEndereco.controls.uf.untouched && !formEndereco.controls.uf.pristine ? 'is-invalid' : ''">
                    <option selected disabled value="">Selecione</option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                </select>
                <input-feedback label="UF" [control]="formEndereco.controls.uf"></input-feedback>
            </div>
        </div>
        <!-- FIM UF -->
    </div>
</form>
<!-- Fim Endereço -->

<!-- Dados Bancários -->
<form [formGroup]="formDadosBancarios" *ngIf="step == 2">
    <div class="row">
        <div class="col-sm col-sm-12 col-md-12 col-lg-11 col-xl-12 d-flex justify-content-center mb-2 mt-2">
            <h2>Dados Bancários</h2>
        </div>
    </div>
    <div class="row">
        <!-- TIPO DE CONTA -->
        <!-- <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="exampleInputEmail1">
                    Tipo de Conta
                </label>
                <select class="custom-select form-control" id="validationTooltip04" formControlName="flagTipoConta"
                    [ngClass]="formDadosBancarios.controls.flagTipoConta.valid && !formDadosBancarios.controls.flagTipoConta.untouched ? 'is-valid' : !formDadosBancarios.controls.flagTipoConta.untouched && !formDadosBancarios.controls.flagTipoConta.pristine ? 'is-invalid' : ''">
                    <option selected disabled value="">Selecione</option>
                    <option value="CC">Conta corrente</option>
                    <option value="CP">Conta poupança</option>
                    <option value="CCC">Conta corrente conjunta</option>
                    <option value="CPC">Conta poupança conjunta</option>
                    <option value="OU">Outros</option>
                </select>
                <input-feedback label="Estado Civil" [control]="formDadosBancarios.controls.flagTipoConta"
                    showSuccess="false">
                </input-feedback>
            </div>
        </div> -->
        <!-- FINAL TIPO DE CONTA -->

        <!-- CONTA -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="numeroConta">Número da Conta</label>
                <input type="text" class="form-control" id="numeroConta" aria-describedby="numeroConta" formControlName="numeroConta"
                    maxlength="10"
                    [ngClass]="formDadosBancarios.controls.numeroConta.valid && !formDadosBancarios.controls.numeroConta.untouched ? 'is-valid' : !formDadosBancarios.controls.numeroConta.untouched && !formDadosBancarios.controls.numeroConta.pristine ? 'is-invalid' : ''">
                <input-feedback label="numeroConta" [control]="formDadosBancarios.controls.numeroConta"></input-feedback>
            </div>
        </div>
        <!-- FINAL CONTA -->

        <!-- BANCO -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="codigoBanco">Código do Banco</label>
                <input type="text" class="form-control" id="codigoBanco" aria-describedby="codigoBanco" formControlName="codigoBanco"
                    maxlength="4"
                    [ngClass]="formDadosBancarios.controls.codigoBanco.valid && !formDadosBancarios.controls.codigoBanco.untouched ? 'is-valid' : !formDadosBancarios.controls.codigoBanco.untouched && !formDadosBancarios.controls.codigoBanco.pristine ? 'is-invalid' : ''">
                <input-feedback label="codigoBanco" [control]="formDadosBancarios.controls.codigoBanco"></input-feedback>
            </div>
        </div>
        <!-- FINAL BANCO -->

        <!-- AGENCIA -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="codigoAgencia">Código da Agencia</label>
                <input type="text" class="form-control" id="codigoAgencia" aria-describedby="codigoAgencia"
                    formControlName="codigoAgencia" maxlength="4"
                    [ngClass]="formDadosBancarios.controls.codigoAgencia.valid && !formDadosBancarios.controls.codigoAgencia.untouched ? 'is-valid' : !formDadosBancarios.controls.codigoAgencia.untouched && !formDadosBancarios.controls.codigoAgencia.pristine ? 'is-invalid' : ''">
                <input-feedback label="Código da Agência" [control]="formDadosBancarios.controls.codigoAgencia"></input-feedback>
            </div>
        </div>
        <!-- FINAL AGENCIA -->

        <!-- DIGITO DA AGENCIA -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="digitoAgencia">Digito da Agencia</label>
                <input type="text" class="form-control" id="digitoAgencia" aria-describedby="digitoAgencia"
                    formControlName="digitoAgencia" maxlength="4"
                    [ngClass]="formDadosBancarios.controls.digitoAgencia.valid && !formDadosBancarios.controls.digitoAgencia.untouched ? 'is-valid' : !formDadosBancarios.controls.digitoAgencia.untouched && !formDadosBancarios.controls.digitoAgencia.pristine ? 'is-invalid' : ''">
                <input-feedback label="Digito da Agência" [control]="formDadosBancarios.controls.digitoAgencia">
                </input-feedback>
            </div>
        </div>
        <!-- FINAL DIGITO DA AGENCIA -->

        <!-- DIGITO DA CONTA -->
        <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="digitoConta">Dígito da Conta</label>
                <input type="text" class="form-control" id="digitoConta" aria-describedby="digitoConta"
                    formControlName="digitoConta" maxlength="4"
                    [ngClass]="formDadosBancarios.controls.digitoConta.valid && !formDadosBancarios.controls.digitoConta.untouched ? 'is-valid' : !formDadosBancarios.controls.digitoConta.untouched && !formDadosBancarios.controls.digitoConta.pristine ? 'is-invalid' : ''">
                <input-feedback label="Digito da Conta" [control]="formDadosBancarios.controls.digitoConta">
                </input-feedback>
            </div>
        </div>
        <!-- FINAL DO DIGITO DA CONTA -->

        <!-- MES CONTA -->
        <!-- <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="mesConta">Mês da Conta</label>
                <input type="number" class="form-control" id="mesConta" aria-describedby="mesConta"
                    formControlName="mesConta" maxlength="16"
                    [ngClass]="formDadosBancarios.controls.mesConta.valid && !formDadosBancarios.controls.mesConta.untouched ? 'is-valid' : !formDadosBancarios.controls.mesConta.untouched && !formDadosBancarios.controls.mesConta.pristine ? 'is-invalid' : ''">
                <input-feedback label="mesConta" [control]="formDadosBancarios.controls.mesConta"></input-feedback>
            </div>
        </div> -->
        <!-- FINAL MES CONTA -->

        <!-- ANO CONTA -->
        <!-- <div class="col-sm col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="form-group">
                <label for="anoConta">Ano da Conta</label>
                <input type="number" class="form-control" id="anoConta" aria-describedby="anoConta"
                    formControlName="anoConta" maxlength="16"
                    [ngClass]="formDadosBancarios.controls.anoConta.valid && !formDadosBancarios.controls.anoConta.untouched ? 'is-valid' : !formDadosBancarios.controls.anoConta.untouched && !formDadosBancarios.controls.anoConta.pristine ? 'is-invalid' : ''">
                <input-feedback label="anoConta" [control]="formDadosBancarios.controls.anoConta"></input-feedback>
            </div>
        </div> -->
        <!-- FINAL ANO CONTA -->
    </div>
</form>
<!-- Fim Dados Bancários -->

<div class="row fixed-bottom">
    <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-light mr-4" (click)="back()">Voltar</button>
        <button class="btn btn-primary ml-4" (click)="next()" [disabled]="formDocumentos.invalid"
            *ngIf="step === 0">Continuar</button>
        <button class="btn btn-primary ml-4" (click)="next()" [disabled]="formEndereco.invalid"
            *ngIf="step === 1">Continuar</button>
        <button class="btn btn-primary ml-4" (click)="next()" [disabled]="formDadosBancarios.invalid"
            *ngIf="step === 2">Continuar</button>
    </div>
</div>